<script lang="ts">
  import { onMount } from "svelte";
  export let altMessage: string | undefined = undefined;
  export let title: string;
  export let text: string | undefined = undefined;
  export let visible: boolean = true;
  export let notifyApp = false;
  export let customClass: string = "";

  const ERROR = "unrecoverableError";
  onMount(() => {
    if (notifyApp && globalThis.ReactNativeWebView) {
      globalThis.ReactNativeWebView.postMessage(ERROR);
    }
  });
</script>

<div class={`${!visible ? `hidden ${customClass}` : customClass} widht-full`}>
</div>
<div class="flex justify-center items-center">
  <div class="p-[24px]">
    <img
      src="/graphics/illust-clouds.svg"
      alt={altMessage}
      class="w-[360px] pb-[32px] h-[auto] mx-auto mt-[48px]"
    />
    <h2 class="pb-[16px]">{title}</h2>
    {#if text}<p>{text}</p>{/if}
    <slot />
  </div>
</div>
